import React from "react";
import "./Admission_Process.css";

const Admission_Process = () => {
  return (
    <section className="Admission_Process" id="admissions">
      <div className="container">
        <div className="col_header">
          <h5 className="col_title">Online BCA Admission Process </h5>
        </div>

        <div className="admission_img_wrapper">
          <img
            src="/assets/edtech_assets/images/online_mba/Admission_Process/img-1.webp"
            className="admission_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Admission_Process;
